import "reflect-metadata";
import {QuoteService} from 'quote-domain-core';
import { container } from 'tsyringe';
import {ConfigCalculator} from "./command/config-calculator";
import { QuoteServiceAppliedPriceUpdateService } from "./service/quote-service/quote-service-applied-price-update-service";
import { QuoteServiceExtraFeeService } from "./service/quote-service/quote-service-extra-fee-service";
import { QuoteServiceTotalPriceService } from "./service/quote-service/quote-service-total-price-service";

export class QuoteServiceManager {

    constructor(
        private readonly extraFeeService: QuoteServiceExtraFeeService = container.resolve(QuoteServiceExtraFeeService),
        private readonly totalPriceService: QuoteServiceTotalPriceService = container.resolve(QuoteServiceTotalPriceService),
        private readonly appliedPriceUpdateService: QuoteServiceAppliedPriceUpdateService = container.resolve(QuoteServiceAppliedPriceUpdateService)
    ) {
    }

    public calculateCorridors(quoteService: QuoteService, referential: any, referentialServices: any, countryIsoCode: string, employeeRole: string): QuoteService{
        const calculator = container.resolve(ConfigCalculator);
        const commandInstance = calculator.getCommandInstance(countryIsoCode, employeeRole, quoteService.code, quoteService, referential, referentialServices);
        if (commandInstance) {
            commandInstance.execute();
        } else {
            console.error("calculator class not found.");
        }
        return quoteService;
    }

    public calculateExtraFeesQtyAndAmount(quoteService: QuoteService): QuoteService {
        this.extraFeeService.calculateExtraFeesQtyAndAmount(quoteService);
        return quoteService;
    }


    public calculateAdditionalStockAmount(quoteService: QuoteService): QuoteService {
        this.totalPriceService.calculateAdditionalStockAmount(quoteService);
        return quoteService;
    }

    public calculateCustomGroupTotalAppliedPrice(quoteService: QuoteService): QuoteService {
        this.totalPriceService.calculateCustomGroupTotalAppliedPrice(quoteService);
        return quoteService;
    }


    public updateServiceAppliedPrice(quoteService: QuoteService, newAppliedPrice: string): QuoteService {
        this.appliedPriceUpdateService.updateServiceAppliedPrice(quoteService, newAppliedPrice);
        return quoteService;
    }

}

